import { defineMessages } from "react-intl";

const messages = defineMessages({
  presetDateFormat: {
    id: "email.emailScheduleSendPopover.presetDateFormat",
    defaultMessage: "EEE, MMM d",
    description: "Date format for preset option subtitles",
  },
  quotaLimitReached: {
    id: "email.emailScheduleSendPopover.quotaLimitReached",
    defaultMessage: "Send limit reached · {total}/{total}",
    description: "Schedule send quota tag when daily send limit is reached",
  },
  quotaSlotsReserved: {
    id: "email.emailScheduleSendPopover.quotaSlotsReserved",
    defaultMessage: "{reserved}/{total} slots reserved · {remaining} remaining",
    description: "Schedule send quota tag showing reserved slots and remaining",
  },
  sendingWindowTimeFormat: {
    id: "email.emailScheduleSendPopover.sendingWindowTimeFormat",
    defaultMessage: "hh:mm a",
    description: "Time format for sending window display",
  },
  sendTimeTooltip: {
    id: "email.emailScheduleSendPopover.sendTimeTooltip",
    defaultMessage: "Based on your org's sending window: {start} - {end} ({timezone})",
    description: "Schedule send time tooltip with org sending window info",
  },
  summaryFormat: {
    id: "email.emailScheduleSendPopover.summaryFormat",
    defaultMessage: "EEE, MMM d h:mm a",
    description: "Date and time format for schedule summary (e.g. Wed, Apr 22 8:00 AM)",
  },
});

export default messages;
